import { API } from 'api';
import { AxiosResponse } from 'axios';
import { IGetServicePaymentsRequest, IGetServicePaymentsResponse } from 'types';
import { API_URL } from 'utils/enums';

class ServicePaymentsService {
	static getAllServicePayments = async (
		reqBody: IGetServicePaymentsRequest
	): Promise<AxiosResponse<IGetServicePaymentsResponse>> => API.post(API_URL.SERVICE_PAYMENTS, reqBody);
}

export { ServicePaymentsService };
